module.exports = __webpack_public_path__ + "static/scale-model-of-permian-basin-charity-golf-crs-in-midland-texas-d2be26bd13a3fff07b205b7b78cd9653.png";